import { createUseStyles } from 'react-jss'

export const useInputPhoneStyles = createUseStyles({
  container: {
    position: 'relative',
  },
  label: {
    marginBottom: 4,
  },
})